import { } from "@/components/icons/bun"
import { 
    DeviconPlainAzureWordmark, 
    DeviconPlainGooglecloud,
    ArcticonsClanguage, 
    DeviconPlainJavaWordmark, 
    RiReactjsFill, 
    MdiTailwind, 
    MdiGit, 
    MdiDocker,
    DeviconPlainMongodbWordmark, 
    DeviconPlainBun,
    NextjsIcon, 
    Fa6BrandsGolang,
    LineiconsPython, 
    AkarIconsTypescriptFill, 
    CibJs, 
    FlowbiteCssSolid, 
    FlowbiteHtmlSolid,
    TeenyiconsNodejsSolid,
    MdiMinecraft,
    SimpleIconsMysql
} from "../components/icons/index"

export const iconComponents = [
    <AkarIconsTypescriptFill width={50} height={50} />,
    <CibJs width={50} height={50} />,
    <FlowbiteCssSolid width={50} height={50} />,
    <FlowbiteHtmlSolid width={50} height={50} />,
    <Fa6BrandsGolang width={50} height={50} />,
    <LineiconsPython width={50} height={50} />,
    <DeviconPlainMongodbWordmark width={50} height={50} />,
    <MdiDocker width={50} height={50} />,
    <MdiGit width={50} height={50} />,
    <MdiTailwind width={50} height={50} />,
    <RiReactjsFill width={50} height={50} />,
    <DeviconPlainBun width={50} height={50} />,
    <NextjsIcon width={50} height={50} />,
    <DeviconPlainJavaWordmark width={50} height={50} />,
    <DeviconPlainGooglecloud width={50} height={50} />,
    <ArcticonsClanguage width={50} height={50} />,
    <DeviconPlainAzureWordmark width={50} height={50} />,
    <TeenyiconsNodejsSolid width={50} height={50} />,   
    <SimpleIconsMysql width={50} height={50} />,    
]
